var Ably = require('ably');
var Preconditions = require('./Preconditions.js');

function RedChirpAbly(rc)
{
    Preconditions.checkNotNull(rc);
    this.$rc = rc;

    this.ably = null;
    this.channels = [];

    this.update();
}

RedChirpAbly.prototype.update = function()
{
    this.unsubscribeAll();
    this.setupAblyClient();

    if ( !this.isAblyClientSetup() ) 
        return;

    if ( !this.$rc.$state.isSignedIn() ) 
        return;
    
    // Organization channel
    this.subscribe(this.$rc.$state.organization_id+":common");

    let employee_endpoints = this.$rc.$state.getEmployeeEndpoints();

    for ( let i = 0; i < employee_endpoints.length; i++ )
    {
        let endpoint = employee_endpoints[i].endpoint;
        this.subscribe(endpoint);
    }
}

RedChirpAbly.prototype.isSubscribed = function(channel_name)
{
    for ( let i = 0; i < this.channels.length; i++ )
    {
        if ( this.channels[i].name == channel_name )
            return true;
    }

    return false;
}

RedChirpAbly.prototype.subscribe = function(channel_name)
{
    if ( this.isSubscribed(channel_name) ) 
    {
        return;
    }

    let channel = this.ably.channels.get(channel_name);
    channel.subscribe((message) => this.$rc.onMessage(message));
    this.channels.push(channel);
}

RedChirpAbly.prototype.unsubscribeAll = function()
{
    for ( let i = 0; i < this.channels.length; i++ )
    {
        this.channels[i].unsubscribe();
    }

    this.channels = [];
}

RedChirpAbly.prototype.isAblyClientSetup = function()
{
    return this.ably != null;
}

RedChirpAbly.prototype.setupAblyClient = function()
{
    if ( this.isAblyClientSetup() )
        return; // already setup

    if ( !this.$rc.$state.isSignedIn() )
        return; // can't setup the ably client

    let ably_settings = this.$rc.$state.profile.ably;

    if ( Preconditions.isNull(ably_settings) || Preconditions.isNull(ably_settings.ably_token) ) 
        return;
    
    this.ably = new Ably.Realtime(ably_settings.ably_token);
}

module.exports = RedChirpAbly;